import { User } from '../types';
import { PlansIds } from '../constants/config';

interface ExperimentsUser {
  id: string;
  plan: string;
  paid: boolean;
  createdAt: number;
}

const { REACT_APP_EXPERIMENTS_URL } = process.env;

const plansMap = new Map<number, string>([
  [0, '-'],
  [1, 'free'],
  [2, 'lite'],
  [3, 'standard'],
  [4, 'standard plus'],
  [5, 'pro'],
  [6, 'appsumo t1'],
  [7, 'appsumo t2'],
  [8, 'appsumo t3'],
  [9, 'kaltura'],
  [10, 'zero'],
  [11, 'starter'],
  [12, 'growth'],
]);

export async function getExperimentsList(user: ExperimentsUser | null) {
  if (!REACT_APP_EXPERIMENTS_URL || !user) return {};

  const result = await fetch(REACT_APP_EXPERIMENTS_URL, {
    method: 'POST',
    headers: { 'content-type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({
      user,
    }),
  });

  return result.json();
}

export function convertUserToExperimentUser(user: User): ExperimentsUser | null {
  const planId = user.subscription?.plan;

  if (!planId) {
    // if user has no any subscription - skip
    return null;
  }

  const isTrial = Boolean(user.subscription?.trial);
  const isUnpaid = isTrial || [PlansIds.ZERO, PlansIds.FREE].includes(planId);

  return {
    id: user.id.toString(),
    plan: plansMap.get(planId) || 'no plan',
    paid: !isUnpaid,
    createdAt: new Date(user.created_at).getTime(),
  };
}
